
const TELEFONE = '554989085829';

/** O time de revenda atende em número próprio, fora do WhatsApp de vendas. */
const TELEFONE_POR_PRODUTO = {
  revenda: '5549988496059',
};

const MENSAGEM_PADRAO = 'Quero saber mais sobre o cardápio digital do ZaperMenu';
const MENSAGEM_POR_PRODUTO = {
  tablet: 'Quero saber mais sobre o cardápio digital no tablet do ZaperMenu',
  revenda: 'Quero ser revenda autorizada do ZaperMenu',
};

/**
 * @param {string|null} produto - `urlParams.produto` da atribuição ('tablet' ou vazio),
 *                                ou 'revenda' quando chamado do quiz de revenda
 * @param {string} [detalhes]   - texto acrescentado abaixo da mensagem (o resumo das
 *                                respostas do quiz de revenda)
 */
export function urlConversaWhatsapp(produto, detalhes) {
  const telefone = TELEFONE_POR_PRODUTO[produto] || TELEFONE;
  const mensagem = [MENSAGEM_POR_PRODUTO[produto] || MENSAGEM_PADRAO, detalhes]
    .filter(Boolean)
    .join('\n\n');
  const isMobile = window.matchMedia('(any-pointer:coarse)').matches;
  const baseUrl = isMobile ? 'whatsapp://' : 'https://api.whatsapp.com/';

  return `${baseUrl}send?phone=${telefone}&text=${encodeURIComponent(mensagem)}`;
}
